import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatusFeed from './components/StatusFeed';
import BackupAddresses from './components/BackupAddresses';
import AccessSteps from './components/AccessSteps';
import TrustStrip from './components/TrustStrip';
import FaqSection from './components/FaqSection';
import UpdateChannels from './components/UpdateChannels';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <StatusFeed />
        <BackupAddresses />
        <AccessSteps />
        <TrustStrip />
        <FaqSection />
        <UpdateChannels />
      </main>
      <SiteFooter />
    </div>
  );
}